module.exports = __webpack_public_path__ + "img/image-placeholder.9cef7303.svg";